import { ApiKeyAction } from './actions';
import * as t from './actionTypes';
import { ApiKey, ApiKeyTypeFormatted } from './types';

export type State = {
  errors: string[];
  isFetching: boolean;
  isModalOpen: boolean;
  keys: ApiKey[];
  keyTypes: ApiKeyTypeFormatted[];
};

export const initialState = {
  errors: [],
  isModalOpen: false,
  isFetching: false,
  keys: [],
  keyTypes: [],
};

const apiKeysReducer = (state: State = initialState, action: ApiKeyAction | undefined) => {
  const success = {
    ...state,
    errors: [],
    isFetching: false,
  };
  switch (action?.type) {
    case t.FETCH_API_KEYS_RESPONSE: {
      return {
        ...success,
        keys: action.payload,
      };
    }

    case t.FETCH_API_KEY_TYPES_RESPONSE: {
      return {
        ...success,
        keyTypes: action.payload,
      };
    }

    case t.FETCH_API_KEYS_REQUEST:
    case t.FETCH_API_KEY_TYPES_REQUEST: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case t.SET_API_KEY_ERRORS: {
      return {
        ...state,
        errors: action.errors,
        isFetching: false,
      };
    }

    default: {
      return state;
    }
  }
};

export default apiKeysReducer;
